"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function strEnum(o) {
  return o.reduce(function (res, key) {
    res[key] = key;
    return res;
  }, Object.create(null));
}

exports.strEnum = strEnum;
exports.EventTypes = [{
  title: "Private Party",
  name: "party"
}, {
  title: "Dance",
  name: "dance"
}, {
  title: "Reception",
  name: "reception"
}, {
  title: "Corporate Event",
  name: "corporate"
}, {
  title: "Banquet",
  name: "banquet"
}, {
  title: "Meeting",
  name: "meeting"
}];
exports.EventNames = strEnum(exports.EventTypes.map(function (eventType) {
  return eventType.name;
}));
exports.VenueTypes = [{
  title: "Restaurant",
  name: "restaurant"
}, {
  title: "Bar",
  name: "bar"
}, {
  title: "Club",
  name: "club"
}, {
  title: "Cafe",
  name: "cafe"
}];
var VenueNames = strEnum(exports.VenueTypes.map(function (venueType) {
  return venueType.name;
}));
exports.VenueFeatures = [{
  title: "AV Equipment",
  name: "av"
}, {
  title: "Bar",
  name: "bar"
}, {
  title: "Outdoor",
  name: "outdoor"
}, {
  title: "Stage",
  name: "stage"
}, {
  title: "Dance Floor",
  name: "dancefloor"
}, {
  title: "DJ Booth",
  name: "djbooth"
}, {
  title: "Private Rooms",
  name: "privaterooms"
}, {
  title: "Off Premise",
  name: "offpremise"
}, {
  title: "Dine-in",
  name: "dinein"
}, {
  title: "Catering",
  name: "catering"
}];
exports.SpaceCostTypes = [{
  name: "FIXED",
  title: "Total"
}, {
  name: "HOUR",
  title: "Per Hour"
}, {
  name: "PERSON",
  title: "Per Person"
}, {
  name: "PERSONHOUR",
  title: "Per Person Per Hour"
}, {
  name: "MINIMUM",
  title: "Minimum"
}];
var SpaceCostNames = strEnum(exports.SpaceCostTypes.map(function (costType) {
  return costType.name;
}));
exports.FoodCostTypes = [{
  name: "FIXED",
  title: "Total"
}, {
  name: "HOUR",
  title: "Per Hour"
}, {
  name: "SERVING",
  title: "Per Serving"
}, {
  name: "PERSON",
  title: "Per Person"
}, {
  name: "PERSONHOUR",
  title: "Per Person Per Hour"
}];
var FoodCostNames = strEnum(exports.FoodCostTypes.map(function (costType) {
  return costType.name;
}));
exports.DrinkCostTypes = [{
  name: "DRINK",
  title: "Per Drink"
}, {
  name: "HOUR",
  title: "Per Hour"
}, {
  name: "PERSON",
  title: "Per Person"
}, {
  name: "PERSONHOUR",
  title: "Per Person Per Hour"
}, {
  name: "TICKET",
  title: "Per Ticket"
}, {
  name: "FIXED",
  title: "Total"
}];
var DrinkCostNames = strEnum(exports.DrinkCostTypes.map(function (costType) {
  return costType.name;
}));
exports.DrinkOptionTypes = [{
  name: "OPENBAR",
  title: "Open Bar"
}, {
  name: "TICKETS",
  title: "Drink Tickets"
}, {
  name: "CASHBAR",
  title: "Cash Bar"
}, {
  name: "DRINK",
  title: "Pay Per Drink"
}];
var DrinkOptionNames = strEnum(exports.DrinkOptionTypes.map(function (optionType) {
  return optionType.name;
}));
exports.FoodOptionTypes = [{
  name: "BREAKFAST",
  title: "Breakfast"
}, {
  name: "BRUNCH",
  title: "Brunch"
}, {
  name: "LUNCH",
  title: "Lunch"
}, {
  name: "DINNER",
  title: "Dinner"
}, {
  name: "BUFFET",
  title: "Buffet"
}, {
  name: "BITES",
  title: "Hors d'oeuvres"
}];
var FoodOptionNames = strEnum(exports.FoodOptionTypes.map(function (optionType) {
  return optionType.name;
}));
exports.VenueOptionTypes = __spreadArrays(exports.DrinkOptionTypes, exports.FoodOptionTypes);